document.addEventListener('DOMContentLoaded', function () {
    let block = document.querySelector('.our-team-2');
    if (typeof Splide !== 'undefined' && block) {
        new Splide('.our-team-2', {
            type: 'loop',
            perPage: 3,
            gap: 20,
            padding: '5%',
            arrows: false,
            pagination: false,
            autoplay: false,

            breakpoints: {
                1024: {
                    perPage: 2,
                    padding: '10%',
                },
                768: {
                    perPage: 2,
                    padding: '5%',
                },
                600: {
                    perPage: 1,
                    padding: '10%',
                },
                450: {
                    perPage: 1,
                    padding: '0%',
                }
            }
        }).mount();
    }
});